const baseProps = {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": true,
    focusable: "false",
};

// Espaces : repère de carte, pour situer un lieu sur le plan
export const PinIcon = (props) => (
    <svg {...baseProps} {...props}>
        <path d="M12 21.7c4.4-4.2 6.6-7.6 6.6-10.3a6.6 6.6 0 1 0-13.2 0c0 2.7 2.2 6.1 6.6 10.3Z" />
        <circle cx="12" cy="10.6" r="2.5" />
    </svg>
);

// Eco-conception : feuille nervurée, pour l'approche environnementale
export const LeafIcon = (props) => (
    <svg {...baseProps} {...props}>
        <path d="M19.5 4.5C10.07 4.73 5.23 9.57 5 19c9.43-.23 14.27-5.07 14.5-14.5Z" />
        <path d="M7.5 16.5 17 7" />
    </svg>
);

// Horaires de restauration : calendrier
export const CalendarIcon = (props) => (
    <svg {...baseProps} {...props}>
        <rect x="3" y="5" width="18" height="16" rx="2.5" />
        <path d="M3 10h18M8 3v4M16 3v4" />
    </svg>
);

// Horaires d'ouverture d'un espace : horloge
export const ClockIcon = (props) => (
    <svg {...baseProps} {...props}>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 7v5.2l3.4 2" />
    </svg>
);

// Chasse aux saveurs : boussole, pour le parcours à travers le campus
export const CompassIcon = (props) => (
    <svg {...baseProps} {...props}>
        <circle cx="12" cy="12" r="9" />
        <path d="m15.9 8.1-2 5.8-5.8 2 2-5.8 5.8-2Z" />
    </svg>
);

// Chasse aux saveurs : couvert, pour le parcours gustatif
export const CutleryIcon = (props) => (
    <svg {...baseProps} {...props}>
        <path d="M6 3v5a2.6 2.6 0 0 0 5.2 0V3" />
        <path d="M8.6 3v5" />
        <path d="M8.6 10.6V21" />
        <path d="M16 21v-7.4" />
        <path d="M16 13.6c2.6-.7 3.9-2.6 3.9-5.6 0-2.4-1.3-4.3-3.9-5v10.6Z" />
    </svg>
);
